module.exports = __webpack_public_path__ + "img/result_fail.2f105ebd.png";